////////////////////////////////////////////////////////////////////////////////
//                                                                            //
//  IRONSIDE - Public Website GUI                                             //
//                                                                            //
//  Version: 1.0.1                                                            //
//  Summary: Horizontal image strip — the "Gallery" module seen on Home/About //
//                                                                            //
////////////////////////////////////////////////////////////////////////////////

import { Img } from '@/components/media/Img';

export interface ImageStripProps {
  images: { src: string; alt: string }[];
}

export function ImageStrip ({ images }: ImageStripProps) {
  return (
    <ul className="flex gap-4 overflow-x-auto">
      {images.map((image) => (
        <li key={image.src} className="shrink-0">
          <Img src={image.src} alt={image.alt} className="h-48 w-auto rounded object-cover" />
        </li>
      ))}
    </ul>
  );
}
